<ul class="app-chips nav nav-pills list-inline" role="input">
  <li class="chip-item" *ngFor="let item of selectedChips; let $index=index">
    <a class="app-chip" href="javascript:void(0);" tabindex="-1" >
      <img data-identifier="img" class="button-image-icon"/>
      {{item}}
      <button type="button" tabindex="-1" class="btn btn-transparent"
        (click)="removeItem($event, $index); $event.stopPropagation();"><i
          class="app-icon wi wi-close"></i></button>
    </a>
  </li>
  <input class="app-chip-input tag-chip-input" type="text" (keydown)="handleEnterKeyPressEvent($event)" [name]="name"
  [(ngModel)]="inputVal" placeholder="Enter Tag Name" />
</ul>
